<template>
  <div
    class="path-activity-panel">
    <ul
      v-if="activity"
      class="list-unstyled">
      <li
        class="path-activity-panel__item mb-3">
        <div
          class="d-flex justify-content-between align-items-center p-2" 
          style="cursor: pointer;">
          <h3 class="path-activity-panel__heading">
            進路活動記録
          </h3>
          <div class="path-activity-panel__box">
            <div class="path-activity-panel__date">
              {{ activity.activityAt | prettyDate }}
            </div>
          </div>
        </div>

        <div
          class="path-activity-panel__body"
          @click="onClickActivityBody">
          <div class="path-activity-panel__record p-2">
            <div class="d-flex justify-content-between">
              <h4 class="path-activity-panel__record-heading mb-4">
                活動記録<span class="path-activity-panel__record-date ml-2">{{ activity.activityAt | prettyDateTime }}</span>
              </h4>
            </div>
            <div class="path-activity-panel__record-text">
              <p>{{ activity.description }}</p>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasCondition() {
      return this.activity.conditionSetting !== null && this.activity.condition !== null
    },
    hasBodyPain() {
      return this.activity.bodyPainSetting?.isRecordBodyPain && this.activity.bodyPain !== null
    },
    isShowConditionPanel() {
      return this.hasCondition || this.hasBodyPain
    }
  },
  methods: {
    onClickActivityBody() {
      this.$emit('click-active')
    }
  }
}
</script>

<style lang="scss" scoped>
.path-activity-panel{
  position: relative;

  &__edit{
    color: $grey01;
    text-decoration: none;
    display: block;
    text-align: right;
    font-weight: bold;
    @media screen and (max-width:320px) {
      font-size: $fs-m;
    }
  }
  &__icon{
    display: inline-block;
    vertical-align: middle;
  }
  &__item{
    border: solid 1px $grey10;
    border-radius: 6px;
  }
  &__file-icon {
    position: absolute;
    top: -10px;
    right: -8px;
  }

  &__heading {
    font-size: $fs-nm;
    font-weight: bold;
    @media screen and (max-width:320px) {
      font-size: $fs-m;
    }
  }
  &__box{
    text-align: right;
  }
  &__count{
    font-size: $fs-m;
    color: $l-blue;
    font-weight: bold;
  }
  &__date{
    font-size: $fs-s;
  }
  &__body{
    border-top: solid 1px $grey10;
  }
  &__record{
    &-heading{
      font-size: $fs-nm;
      font-weight: bold;
      @media screen and (max-width:320px) {
        font-size: $fs-m;
      }
    }
    &-date{
      color: $grey09;
      font-size: $fs-m;
      @media screen and (max-width:320px) {
        font-size: $fs-s;
      }
    }
    &-text{
      font-size: $fs-nm;
      color: $grey17;
      white-space:pre-wrap;
      word-wrap:break-word; 
      @media screen and (max-width:320px) {
        font-size: $fs-m;
      }
    }
  }
}
</style>